import { Components, Theme } from '@mui/material/styles';

export const flowInput: Components<Theme>['MuiInput'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      '&.Mui-disabled': {
        '&:before': {
          borderBottomStyle: 'solid',
        },
      },
    },
  },
};
